<template>
  <div class="position-relative">
    <label class="teams-label-font"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <div
      class="mt-2 newUploadDoc relativeclass"
      v-b-tooltip.hover.html.bottom
      :title="tooltipContent"
      :class="{
        validationinputfile: showError || maxSize || invalidFile,
        'box-size-docs': id === 'feedback',
        disableuploadDoc: disabled,
      }"
    >
      <b-form-file
        :disabled="disabled"
        ref="uploadFiles"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        v-model="inputData"
        @input="uploadFile"
        :accept="acceptedFileTypes"
        tabindex="0"
      >
      </b-form-file>
      <div
        v-if="!isFileUploaded"
        class="
          newUploadDoc-innerContent
          d-flex
          align-items-center
          justify-content-center
          h-100
          w-100
        "
      >
        <div
          id="laptop-upload"
          class="d-flex align-items-center justify-content-center h-100 w-100"
        >
          <img
            src="../../assets/New-imgs/CustVend-icons/manage-upload-icon.svg"
            alt=""
          />
          <span class="newUploadDoc-innerContent-font-blk ml-2">
            Drag & Drop or
          </span>
          <span class="newUploadDoc-innerContent-font-blue ml-2">
            Browse file
          </span>
        </div>
        <div
          id="mobile-upload"
          class="
            d-flex
            align-items-center
            justify-content-between
            h-100
            w-100
            px-2
          "
        >
          <div>
            <div class="asp-small-grey-txt-2">Upload File</div>
            <div class="mobjd-light-txt mt-1">
              {{ mobileFileFormatContent }}
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="asp-vertical-line mr-2"></div>
            <div>
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-upload-icon.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="newUploadDoc-innerContent h-100 w-100">
        <div
          id="laptop-upload"
          class="
            relativeclass
            d-flex
            align-items-center
            justify-content-between
            h-100
            w-100
          "
        >
          <div class="newUploadDoc-innerContent-left d-flex" style="width: 80%">
            <img
              src="../../assets/New-imgs/CustVend-icons/manage-empty-resume-file.svg"
              alt=""
            />
            <div
              class="newUploadDoc-innerContent-font-blk ml-2 text-truncate mt-1"
              style="max-width: 100%"
            >
              {{ uploadedFileName }}
            </div>
          </div>
          <div class="resume-spinner" v-if="showResumeLoader">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          <div v-else>
            <img
              :class="disabled && id === 'addDocument' && 'disabled-kanban-img'"
              class="newUploadDoc-innerContent-replace ml-1"
              src="../../assets/New-imgs/CustVend-icons/manage-replace-icon.svg"
              alt=""
            />

            <img
              class="newUploadDoc-innerContent-delete"
              @click.stop="removeFile()"
              src="../../assets/New-imgs/CustVend-icons/manage-cancel-resume-icon.svg"
              alt=""
            />
          </div>
        </div>
        <div
          id="mobile-upload"
          class="d-flex align-items-center pt-2 justify-content-between px-2"
        >
          <div class="d-flex">
            <div>
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-empty-resume-file.svg"
                alt=""
              />
            </div>
            <div class="asp-small-grey-txt-2 ml-1 mt-1 text-truncate">
              {{ uploadedFileName }}
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="px-2">
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-replace-icon.svg"
              />
            </div>
            <div @click.stop="removeFile()" class="px-1">
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-cancel-resume-icon.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="newInt-required-validation-font mt-1"
      v-if="!showError && invalidFile"
    >
      Invalid File Format
    </div>
    <div
      class="newInt-required-validation-font mt-1"
      v-else-if="!showError && maxSize"
    >
      Max size exceeded
    </div>
  </div>
</template>

<script>
import toast from "../../components/mixin/toast";
export default {
  name: "UploadDocument",
  mixins: [toast],
  props: {
    disabled: Boolean,
    mandatory: Boolean,
    showError: Boolean,
    type: String,
    label: String,
    placeholder: String,
    id: String,
    maxFileSize: String,
    fileFormat: Array,
    showResumeLoader: Boolean,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      inputData: null,
      isFileUploaded: false,
      maxSize: false,
      invalidFile: false,
      uploadedFileName: null,
      extension: "",
    };
  },
  watch: {
    vmodel(newVal) {
      if (
        this.id === "addDocument" &&
        Array.isArray(newVal) &&
        newVal.length > 0
      ) {
        this.checkAndSetName(newVal);
      }
    },
  },
  created() {
    if (
      this.id === "addDocument" &&
      Array.isArray(this.vmodel) &&
      this.vmodel.length > 0
    ) {
      this.checkAndSetName(this.vmodel);
    } else if (this.vmodel && this.vmodel != "" && this.vmodel != undefined) {
      if (typeof this.vmodel != "object") {
        let lastIndex = this.vmodel.lastIndexOf("/");
        let some = this.vmodel.substring(lastIndex + 1);
        this.uploadedFileName = some;
      } else {
        this.uploadedFileName = this.vmodel.name;
      }
      // this.inputData = this.vmodel;
      this.isFileUploaded = true;
    }
  },
  mounted() {
    const fileTag = this.$refs.uploadFiles.$el;
    fileTag.addEventListener("drop", this.handleDrop);
  },
  beforeDestroy() {
    const fileTag = this.$refs.uploadFiles.$el;
    fileTag.removeEventListener("drop", this.handleDrop);
  },
  computed: {
    tooltipContent() {
      if (this.id == "addDocument" && this.disabled && !this.isFileUploaded) {
        return "Please add file format and file size limit to upload document";
      } else if (!this.isFileUploaded) {
        return `
        Upload your ${this.label}<br>
        (${this.fileFormat.join(", ")})
        max ${this.maxFileSize} MB
      `;
      } else {
        return "";
      }
    },

    acceptedFileTypes() {
      const fileExtensions = this.fileFormat.map((format) => `.${format}`);
      return fileExtensions.join(",");
    },

    mobileFileFormatContent() {
      if (!this.isFileUploaded) {
        return `
        (${this.fileFormat.join(", ")})
        max ${this.maxFileSize} MB
      `;
      } else {
        return "";
      }
    },
  },
  methods: {
    checkAndSetName(vmodel) {
      const fullUrl = vmodel[0];
      this.uploadedFileName = decodeURIComponent(
        fullUrl.split("/").pop().split("?")[0]
      );
      // this.inputData = vmodel;
      this.isFileUploaded = true;
    },
    handleDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        this.processFile(file);
      }
    },
    uploadFile(event) {
      if (event instanceof File) {
        this.processFile(event);
      }
    },
    processFile(file) {
      const fileName = file.name;
      const fileSize = file.size;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      const allowedExtensions = this.fileFormat.map((ext) => ext.toLowerCase());

      if (fileSize > this.maxFileSize * 1024 * 1024) {
        this.errorModal("File size exceeds maximum allowed size");
        this.maxSize = true;
        return;
      } else if (allowedExtensions.includes(fileExtension)) {
        this.maxSize = false;
        this.invalidFile = false;
        const reader = new FileReader();
        reader.onload = (e) => {
          console.error(e);
          this.uploadedFileName = fileName;
          this.isFileUploaded = true;
          this.inputData = file;
          this.$emit("select-value", this.inputData);
          this.$emit("reupload-value", true);
          this.$emit("update-check");
        };
        reader.readAsBinaryString(file);
      } else {
        console.error("Invalid file format");
        this.invalidFile = true;
        this.errorModal("Invalid file format");
        this.maxSize = false;
      }
    },
    removeFile() {
      this.inputData = null;
      this.$emit("select-value", this.inputData);
      this.isFileUploaded = false;
      this.uploadedFileName = null;
      this.maxSize = false;
      this.invalidFile = false;
    },
  },
};
</script>

<style scoped>
.newUploadDoc-innerContent-left {
  padding: 10px !important;
}

.newUploadDoc-innerContent-replace {
  position: absolute;
  cursor: pointer;
  top: 7px;
  right: 45px;
}

.newUploadDoc-innerContent-delete {
  position: absolute;
  z-index: 5;
  cursor: pointer;
  top: 8px;
  right: 10px;
}

/* Media query for laptop view */
@media (min-width: 768px) {
  #mobile-upload {
    display: none !important;
  }
}

@media only screen and (max-width: 767px) {
  #laptop-upload {
    display: none !important;
  }
}

.asp-small-grey-txt {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #3a3c40;
}

.asp-small-grey-txt-2 {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #3a3c40;
}

.asp-vertical-line {
  background-color: #d9d9d9;
  height: 21px;
  width: 1px;
}

.mobjd-light-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 8px;
  font-weight: 400;
  color: #475467;
}
</style>
<style>
@media only screen and (max-width: 600px) {
  .newUploadDoc .custom-file {
    width: 90% !important;
  }
}
.resume-spinner .spinner-border {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: -0.125em;
  border: 0.25em solid rgb(40 104 156);
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}
.resume-spinner {
  margin-top: 7px;
  padding: 0px 7px !important;
}
</style>
